var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkynityLogoGraphic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 65,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6254EC",
    fillRule: "evenodd",
    d: "m.426 11.532-.004.002v12.872c0 2.044 1.578 3.702 3.526 3.702 1.947 0 3.525 1.657 3.525 3.701v10.425c0 2.118 1.647 3.836 3.664 3.836 2.018 0 3.664-1.718 3.664-3.836v-3.16c0-2.09 1.614-3.784 3.604-3.784s3.604 1.694 3.604 3.784v4.042c0 2.09 1.614 3.783 3.604 3.783h.307c1.82 0 3.296 1.55 3.296 3.46 0 1.911 1.476 3.46 3.296 3.46h.29c1.98 0 3.586 1.686 3.586 3.766v3.223c0 2.118 1.646 3.836 3.664 3.836 2.017 0 3.664-1.718 3.664-3.836V48.936c0-2.095 1.617-3.793 3.613-3.793 1.995 0 3.613 1.698 3.613 3.793v.55c0 2.118 1.646 3.835 3.663 3.835 2.018 0 3.664-1.717 3.664-3.835V39.88c0-2.119 1.637-3.836 3.655-3.836s3.655-1.717 3.655-3.836V11.702c-.032 1.387-1.512 2.768-4.44 3.62l-22.837 6.644c-3.225.938-7.378.938-10.603 0L4.863 15.322c-2.96-.86-4.441-2.263-4.441-3.665 0-.042.001-.083.004-.125Zm65.153.08v-.003.003Zm-43.69 43.597c0 2.118-1.647 3.836-3.665 3.836s-3.664-1.718-3.664-3.836v-2.912c0-2.119 1.646-3.836 3.664-3.836 2.018 0 3.664 1.717 3.664 3.836v2.912Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A0CA3",
    d: "M4.863 7.991c-5.921 1.723-5.921 5.61 0 7.332l22.836 6.643c3.225.938 7.378.938 10.603 0l22.836-6.643c5.922-1.723 5.922-5.61 0-7.332L38.302 1.348C35.077.41 30.924.41 27.7 1.348L4.863 7.99Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkynityLogoGraphic);
export default __webpack_public_path__ + "static/media/skynity-logo-graphic.1d9911627bc65ada33d6d6ebc556b0fe.svg";
export { ForwardRef as ReactComponent };